import { trackEvent } from '../lib/tracking';
import { WHATSAPP_BASE, WHATSAPP_GENERIC_MESSAGE } from '../lib/constants';

const serviceLine = ['Mobiliário', 'Divisórias', 'Acústica', 'Carpetes', 'Marcenaria'];

export default function HeroSection() {
  return (
    <section className="relative bg-background-50 pt-28 md:pt-40 pb-16 md:pb-24">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Texto */}
          <div className="w-full">
            <p className="text-[12px] md:text-[13px] font-semibold tracking-[0.28em] uppercase text-primary-500 mb-6">
              Soluções corporativas completas
            </p>

            <h1 className="text-foreground-950 text-[32px] leading-[1.1] md:text-[52px] font-semibold tracking-tight mb-6">
              Sua empresa está abrindo, ampliando, reformando ou mudando de endereço?
            </h1>

            <p className="text-foreground-600 text-[16px] md:text-[18px] leading-relaxed max-w-lg mb-6">
              Projetamos e implantamos ambientes corporativos completos, integrando mobiliário,
              divisórias, carpetes, acústica e marcenaria.
            </p>

            {/* Linha de serviços */}
            <div className="flex items-center flex-wrap gap-x-3 gap-y-2 mb-8">
              {serviceLine.map((item, i) => (
                <span key={item} className="flex items-center gap-3">
                  <span className="text-foreground-800 text-[14px] md:text-[15px] font-medium">
                    {item}
                  </span>
                  {i < serviceLine.length - 1 && (
                    <span className="w-1 h-1 rounded-full bg-primary-400"></span>
                  )}
                </span>
              ))}
            </div>

            {/* Qualificação de posicionamento */}
            <div className="flex flex-col gap-2 mb-8">
              <div className="inline-flex items-center gap-2.5 text-[13px] text-foreground-700">
                <i className="ri-building-2-line text-primary-500 text-base flex-shrink-0"></i>
                <span>Foco em projetos corporativos de maior porte.</span>
              </div>
              <div className="inline-flex items-center gap-2.5 text-[13px] text-foreground-600 font-medium">
                <i className="ri-arrow-right-up-line text-primary-500 text-base flex-shrink-0"></i>
                <span>Atendimento prioritário para projetos <strong className="text-foreground-800">a partir de R$ 50 mil</strong>.</span>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <a
                href="#qualificacao"
                onClick={() => trackEvent('form_start', { source: 'hero' })}
                className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-white text-[14px] font-semibold px-7 py-4 rounded-full transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                Solicitar análise do meu projeto
                <i className="ri-arrow-down-line text-base"></i>
              </a>
              <a
                href={`${WHATSAPP_BASE}?text=${WHATSAPP_GENERIC_MESSAGE}`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent('whatsapp_projeto_corporativo', { location: 'hero' })}
                className="inline-flex items-center justify-center gap-2 border border-background-300 text-foreground-800 hover:bg-background-100 text-[14px] font-semibold px-7 py-4 rounded-full transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                Falar com um especialista
                <i className="ri-whatsapp-line text-base"></i>
              </a>
            </div>
          </div>

          {/* Imagem */}
          <div className="w-full">
            <div className="relative rounded-2xl overflow-hidden bg-background-100 aspect-[4/3]">
              <img
                src="/media/projetos/c535bae2-005a3323-2fe5-4f55-95c4-7d767307d9d1.webp"
                alt="Projeto corporativo completo entregue pela Home Office Premium"
                title="Projeto corporativo Home Office Premium"
                className="w-full h-full object-cover object-top"
                fetchPriority="high"
              />
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2 bg-white/90 backdrop-blur rounded-full px-4 py-2.5">
                <i className="ri-building-2-line text-primary-500 text-base"></i>
                <span className="text-foreground-800 text-[12px] font-medium truncate">
                  Ambiente corporativo real entregue pela Home Office Premium
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}